import { defineSlotRecipe } from '@chakra-ui/react';

import { SEARCH_ENGINE } from '../../../consts';

const containerStyle = {
    gridTemplateColumns: `var(--first-col-width, ${SEARCH_ENGINE.DESKTOP_FIRST_COLUMN_WIDTH}) auto var(--range-picker-width, 3fr) auto var(--guest-picker-width, 3fr) auto`,
    justifyContent: 'space-between',
    bg: 'white',
    boxShadow: 'searchBar',
    borderRadius: 'xl',
    borderBottomLeftRadius: 'var(--border-bottom-left-radius, 0)',
    gap: 'var(--grid-gap, 1rem)',
    px: 'gutterWidth',
    '--element-height': '4.875rem',
};

export const searchEngineDesktopSlotRecipe = defineSlotRecipe({
    slots: [
        'separator',
        'guestPickerTrigger',
        'locationInput',
        'rangePickerInput',
        'submit',
        'wrapper',
        'mapSearchWrapper',
        'instantReservationCheckboxWrapper',
    ],
    base: {
        wrapper: { ...containerStyle },
        mapSearchWrapper: {
            '--first-col-width': SEARCH_ENGINE.MAP_SEARCH_FIRST_COLUMN_WIDTH,
            '--border-bottom-left-radius': '12px',
            '--grid-gap': 0,
            '--range-picker-width': SEARCH_ENGINE.MAX_PICKER_WIDTH,
            '--guest-picker-width': SEARCH_ENGINE.MAX_PICKER_WIDTH,
            maxW: SEARCH_ENGINE.MAX_WIDTH,
            ...containerStyle,
            '@media (max-width: 1450px)': {
                '--first-col-width': '3fr',
                '--range-picker-width': '265px',
                '--guest-picker-width': '3fr',
            },
        },
        guestPickerTrigger: {
            borderRadius: 0,
            w: '100%',
            pr: 0,
            pl: 3,
            border: 0,
            justifyContent: 'flex-start',
            fontSize: 'md',
            _hover: {
                bg: 'none',
            },
            h: 'var(--element-height)',
        },
        locationInput: {
            border: 0,
            borderRadius: 0,
            h: 'var(--element-height)',
            // _focusVisible: {
            //     border: 0,
            // },
        },
        separator: {
            bgColor: '{colors.border}',
            w: '1px',
            my: 'gutterWidth',
        },
        submit: {
            my: 'auto',
        },
        instantReservationCheckboxWrapper: {
            md: {
                w: `calc(${SEARCH_ENGINE.DESKTOP_FIRST_COLUMN_WIDTH} + 2 * {spacing.gutterWidth})`,
            },
        },
    },
});
